import React from 'react';
import { RootState } from '../../../reduxToolkit/store';
import { useSelector } from '../../../reduxToolkit/typedRedux';

interface EmptyComponentProps {
  componentName: string;
  height?: number;
}

const EmptyComponent = ({ componentName, height }: EmptyComponentProps) => {
  const templateEditMode = useSelector((state: RootState) => state.common.templateEditMode);

  return (
    <div
      className={`min-h-[25px] w-full grid place-items-center relative font-bold transition-all ${templateEditMode ? 'backdrop-blur-sm' : ''}`}
      style={{ height: height ?? '50px' }}>
      {templateEditMode && (
        <>
          <p className="z-10 font-bold text-white transition-opacity">{componentName}</p>
          <div className="absolute w-full h-full transition-all bg-gray-400 rounded-md shadow-sm opacity-50 t-0 l-0" />
        </>
      )}
    </div>
  );
};

export default EmptyComponent;
